import { lazy, Suspense } from "react";

import type { IMultiAnalysisDataMark } from "../../../multi-analysis/types";
import type { ISpeedScreenFormContentProps, ISpeedScreenFormStrategy, ISpeedScreenFormTimePanelProps } from "../types";
import { isBodeDataMark } from "./model";
import { BodeTimePanel } from "./time-panel";
import { BodeDataMarkTooltip } from "./tooltip";

const BodeScreenForm = lazy(() => import("./view").then(module => ({ default: module.BodeScreenForm })));

export class BodeScreenFormStrategy implements ISpeedScreenFormStrategy {
  readonly id = "bode" as const;
  readonly titleId = "pages.speed.screenForms.bode";
  readonly measureType = null;

  render(props: ISpeedScreenFormContentProps) {
    return (
      <Suspense fallback={null}>
        <BodeScreenForm {...props} />
      </Suspense>
    );
  }

  renderTimePanel(props: ISpeedScreenFormTimePanelProps) {
    return <BodeTimePanel {...props} />;
  }

  renderDataMarkTooltip(mark: IMultiAnalysisDataMark) {
    return isBodeDataMark(mark) ? <BodeDataMarkTooltip mark={mark} /> : null;
  }
}
